import React from 'react';
import { Form, Header } from 'semantic-ui-react';
import RichTextEditor from '../../RichTextEditor';
import Metadata from '../Metadata';

const details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Form.Field>
        <Form.Input
          label="Titre"
          placeholder="Titre"
          id="title"
          value={obj.translations[language.code].title}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Ouverture</label>
        <RichTextEditor
          id="opening"
          value={obj.translations[language.code].opening}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <label>Fermeture exceptionnelle</label>
        <RichTextEditor
          id="closing_time"
          value={obj.translations[language.code].closing_time}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Label du bouton Push"
          id="push_cta_label"
          fluid
          label="Label du bouton Push"
          value={obj.translations[language.code].push_cta_label}
          onChange={(e) => onChange(e, language.code)}
        />
        <Form.Input
          placeholder="https://..."
          id="push_cta_url"
          fluid
          label="Adresse cible"
          value={obj.translations[language.code].push_cta_url}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Group>
      <Header as="h3">Bloc Instagram</Header>
      <Form.Field>
        <Form.Input
          label="Titre de la section"
          placeholder="Titre de la section"
          id="section_instagram_title"
          value={obj.translations[language.code].section_instagram_title || ''}
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Metadata obj={obj} language={language} onChange={onChange} />
    </div>
  );
};

export default details;



// WEBPACK FOOTER //
// ./src/components/form/practicalInfo/details.js